import './style/css/globals.css';
import Home from './pages/Home';
import { useSelector } from 'react-redux';

function App() {
  const {theme} = useSelector((state) => state.globalReducer)

  return (
    <div className={"big-container "+ theme}>
      <Home/>
    </div>
  );
}

export default App;
